import { Box, Button, Modal } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useContext } from 'react';
import HomeContext from 'src/store/home-context';
import { colors } from 'src/styles/theme';

const modalStyle = {
  position: 'absolute',
  display: 'flex',
  flexDirection: 'column',
  top: '50%',
  left: '50%',
  cursor: 'pointer',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: `2px solid ${colors.primary.dark}`,
  borderRadius: '10px',
  boxShadow: 24,
  p: 4,
  maxHeight: '90%',
  overflow: 'auto',
  mb: '1rem',
  width: {
    lg: '40%',
    md: '65%',
    sm: '80%',
    xs: '95%',
  },
};

export default function IneligibleModal() {
  const { ineligibleModal } = useContext(HomeContext);
  const { closeModal, open } = ineligibleModal;
  return (
    <Modal open={open} onClose={closeModal}>
      <Box sx={modalStyle}>
        <Box sx={{ display: 'flex', justifyContent: 'end', mb: '2rem' }}>
          <CloseIcon
            sx={{
              color: 'grey',
              cursor: 'pointer',
              float: 'right',
            }}
            onClick={closeModal}
          />
        </Box>
        <Box>
          Your account requires itemization. Please add your company assets on steps 3 and 4.
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'end', mt: '1rem' }}>
          <Button data-cy="close" type="submit" variant="contained" onClick={closeModal}>
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
